export default __webpack_public_path__ + "static/0287-5cfc40b5f719ac6838aadfd8f3da1a71.png";